import React from 'react';

import CmsElement from 'Components/Utilities/CmsElement';
import { Loading } from 'Components/Partials';
import { RenderWYSIWYG } from 'Components/Form';

import { translation } from 'Services/TranslationHelpers';
import { getRecordValue } from 'Services/CmsHelpers';
import Authenticated from "Components/Layouts/Fragrance/Authenticated";

export default class Speakers extends CmsElement {
    /**
     * @var cmsElementIdentifier
     * @type {string}
     */
    cmsElementIdentifier = 'speakers';

    /**
     * @var paginate
     * @type {boolean}
     */
    paginate = false;

    /**
     * @var allowUpdate
     * @type {boolean}
     */
    allowUpdate = true;

    /**
     * @var state
     */
    state = {
        working: true,
    };

    /**
     * @method render
     * @return {*}
     */
    render() {
        const { working, records } = this.state;

        return (
            <Authenticated >
                <h2 className="text-black text-5xl h1 my-4 font-bold text-center boots-sharp">
                    Speakers
                </h2>

                <p className="mt-4 mb-10 text-center">
                    We have a whole host of speakers joining us.
                </p>

                {working && <Loading/>}

                {!working && (
                    <>
                        {records !== null && (!records.data || records.data.length === 0) && (
                            <p className="text-center text-app-blue">
                                {translation('misc', 'no_items', {
                                    item: 'speakers',
                                })}
                            </p>
                        )}

                        {records && records.data && (
                            <div className="my-8 text-app-blue">
                                <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-12">
                                    {records.data
                                        .sort((a, b) => getRecordValue(a, 'order') - getRecordValue(b, 'order'))
                                        .map((item) => this.renderSpeaker(item))}
                                </div>
                            </div>
                        )}
                    </>
                )}
            </Authenticated>
        );
    }

    /**
     * @method renderSpeaker
     * @type {object} item
     * @return {*}
     */
    renderSpeaker(item) {

        return (
            <div key={item.id}>
                <div className="relative aspect-w-15 aspect-h-5">
                    <img
                        src={getRecordValue(item, 'profile_picture','file')}
                        className="absolute inset-0 h-full w-full object-scale-down p-2"
                    />
                </div>

                <div className="text-black py-4  text-center">
                    <h3 className="uppercase text-lg font-bold ">
                        {getRecordValue(item, 'name')}
                    </h3>
                </div>
            </div>
        );
    }
}
